import React, { useState } from 'react'
import { MdDelete } from 'react-icons/md'
import AppLayout from '../components/AppLayout'
import {v4 as uuidv4} from 'uuid'
import { addPlan } from '../logic/plans/action'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'

const AddPlans = () => {
  const [features, setfeatures] = useState([]);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [data, setdata] = useState({
    name:'',
    price:10,
    customer_limit:0,
    staff_limit:0,
    appointment_limit:0,
    storage_limit:0,
    service_limit:0,
    sms_limit:0,
  });
  const addplanClick = ()=>{
    console.log('clicked');
      addPlan(dispatch,{...data,features:features.map(e=>e.value).join('-'),fetures:features.map(e=>e.value).join('-')},navigate);
  }
  return (
    <AppLayout>
        <div className='flex-1 h-full overflow-y-scroll flex flex-col items-center gap-10 p-10 justify-center'>
        <h1 className='mt-10'>Add New Plan</h1>
        <div className='w-1/2 flex flex-col items-center gap-4'>
          <div className='w-full flex flex-col items-start gap-2'>
        <label htmlFor="name">Plan Name</label>
        <input placeholder='Plan Name' name='name' id='name' value={data.name} onChange={(ev)=>{setdata(prev=>({...prev,[ev.target.name]:ev.target.value}))}}/>
          </div>
          <div className='w-full flex flex-col items-start gap-2'>
        {/* <input placeholder='Plan Price'/> */}
        <label htmlFor="patient_limit">Patient Limit</label>
        <input placeholder='Patient Limit' name='patient_limit' id='patient_limit' value={data.patient_limit || data.customer_limit} onChange={(ev)=>{setdata(prev=>({...prev,[ev.target.name]:ev.target.value}))}}/>
          </div>
          <div className='w-full flex flex-col items-start gap-2'>
        <label htmlFor="staff_limit">Staff Limit</label>
        <input placeholder='Staff Limit' name='staff_limit' id='staff_limit' value={data.staff_limit} onChange={(ev)=>{setdata(prev=>({...prev,[ev.target.name]:ev.target.value}))}}/>
          </div>
          <div className='w-full flex flex-col items-start gap-2'>
        <label htmlFor="storage_limit">Storage Limit</label>
        <input placeholder='Storage Limit' name='storage_limit' id='storage_limit' value={data.storage_limit} onChange={(ev)=>{setdata(prev=>({...prev,[ev.target.name]:ev.target.value}))}}/>
          </div>
          <div className='w-full flex flex-col items-start gap-2'>
        <label htmlFor="service_limit">Service Limit</label>
        <input placeholder='Service Limit' name='service_limit' id='service_limit' value={data.service_limit} onChange={(ev)=>{setdata(prev=>({...prev,[ev.target.name]:ev.target.value}))}}/>
          </div>
          <div className='w-full flex flex-col items-start gap-2'>
        <label htmlFor="appointment_limit">Appointment Limit</label>
        <input placeholder='Appointment Limit' name='appointment_limit' id='appointment_limit' value={data.appointment_limit} onChange={(ev)=>{setdata(prev=>({...prev,[ev.target.name]:ev.target.value}))}}/>
          </div>
          <div className='w-full flex flex-col items-start gap-2'>
        <label htmlFor="ams_limit">SMS Limit</label>
        <input placeholder='SMS Limit' name='sms_limit' id='sms_limit' value={data.sms_limit} onChange={(ev)=>{setdata(prev=>({...prev,[ev.target.name]:ev.target.value}))}}/>
          </div>
        <div className='flex items-center justify-between w-full'>
          <p>Add Feature</p>
          <button
          onClick={()=>setfeatures(prev=>([...prev,{
            id:uuidv4(),
            value:''
          }]))}
          >+</button>
        </div>
        {
          features.map(
            (e,i)=>
        <div className='flex items-stretch gap-4 w-full' key={i}>
          <input type="text" placeholder='add feture' value={e.value} onChange={(ev)=>
          {
            let arr = [...features];
            arr[i].value = ev.target.value;
            setfeatures(arr);
          }
          }/>
          <button onClick={()=>setfeatures(prev=>prev.filter(el=>el.id!==e.id))} className='flex items-center justify-center'><MdDelete/></button>
        </div>
          )
        }
        <button onClick={addplanClick}>ADD PLAN</button>
        </div>
        </div>
    </AppLayout>
  )
}

export default AddPlans